import { Lock } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";
import type { SubscriptionPlan } from "~/lib/hooks/use-subscription";

const planLabels: Record<SubscriptionPlan, string> = {
	FREE: "Zdarma",
	PREMIUM: "Premium",
	PRO: "Pro",
	ENTERPRISE: "Enterprise",
};

interface PaywallOverlayProps {
	requiredPlan: SubscriptionPlan;
	children: ReactNode;
}

export function PaywallOverlay({ requiredPlan, children }: PaywallOverlayProps) {
	return (
		<div className="relative">
			<div className="pointer-events-none select-none blur-sm">{children}</div>
			<div className="absolute inset-0 flex flex-col items-center justify-center rounded-lg bg-background/80 backdrop-blur-[2px]">
				<Lock className="h-8 w-8 text-muted-foreground" />
				<p className="mt-3 text-sm font-medium text-foreground">
					Tato funkce vyžaduje plán {planLabels[requiredPlan]}
				</p>
				<Link to="/cenik" className="mt-3 btn btn-sm btn-primary">
					Upgradovat
				</Link>
			</div>
		</div>
	);
}
